import axios from 'axios'
import router from '../router/new.js'
import { ElMessage } from 'element-plus'

const instance = axios.create({
  // 使用相对路径，HTTP / HTTPS 都走当前网站域名，避免混合内容拦截
  baseURL: '/api'
})

const isAdminRoute = () => {
  const path = router.currentRoute.value?.path || ''
  return path.startsWith('/admin')
}

instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => response.data,
  error => {
    const silent = error.config?.silent === true
    const admin = isAdminRoute()

    if (error.response?.status === 401 && admin) {
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      router.push({
        path: '/admin/login',
        query: { redirect: router.currentRoute.value.fullPath }
      })
      ElMessage.error('登录已过期，请重新登录')
    } else if (admin && !silent) {
      ElMessage.error(error.response?.data?.message || '请求失败')
    }
    return Promise.reject(error)
  }
)

export default instance
